import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  createMerchantService,
  deleteMerchantService,
  getMerchantInfoService,
  updateMerchantService,
} from '../services/merchant.service';
import {
	TCreateMerchantReqData,
	TGetMerchantsListParams,
	TGetMerchantsListResData,
	TUpdateMerchantReqData,
} from '../types/merchant.types';

export const useGetMerchantsListQuery = (
  counterpartyGUID: string,
  params: TGetMerchantsListParams,
  options?: any
): UseQueryResult<TGetMerchantsListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.MerchantQueryKeys].getMerchantsList(counterpartyGUID, params),
    ...options
  });

export const useCreateMerchantMutation = (): any =>
  useMutation({
    mutationFn: (
      data: {
        counterpartyGUID: string,
        requestData: TCreateMerchantReqData
      }) => createMerchantService(data.counterpartyGUID, data.requestData),
  });

export const useGetMerchantInfoMutation = (): any =>
  useMutation({
    mutationFn: (data: { merchantGUID: string }) => getMerchantInfoService(data.merchantGUID),
  });

export const useUpdateMerchantMutation = (): any =>
  useMutation({
    mutationFn: (data: { merchantGUID: string, requestData: TUpdateMerchantReqData }) =>
      updateMerchantService(data.merchantGUID, data.requestData),
  });

export const useDeleteMerchantMutation = (): any =>
  useMutation({
    mutationFn: (data: { merchantGUID: string }) => deleteMerchantService(data.merchantGUID),
  });
